import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagCoordinatorProps {}

const ColorTagCoordinator: React.FC<ColorTagCoordinatorProps> = props => {
  return <ColorTag className="ColorTagCoordinator" color="deepPurple" appearance="translucent">Coordinator</ColorTag>
}

export default ColorTagCoordinator;